"use client";

import { useRouter } from "next/navigation";
import { Center, H3, List, Modal, Stack, Text } from "@/components/ui/elements";
import { EditIcon } from "@/components/ui/elements/icon";
import { AlertField } from "@/components/ui/parts";

import { ReactivationRequestForm } from "./ReactivationRequestForm";

type ReactivationRequestModalProps = {
  opened: boolean;
  onClose: () => void;
  phoneNumber: string;
};

export function ReactivationRequestModal({
  opened,
  onClose,
  phoneNumber,
}: ReactivationRequestModalProps) {
  const router = useRouter();

  /** フォーム送信成功時: モーダルを閉じ、サインアップ画面へ遷移（全画面共通） */
  const handleSuccess = (_status?: string) => {
    onClose();
    if (
      typeof window !== "undefined" &&
      window.opener &&
      !window.opener.closed
    ) {
      const baseUrl = window.location.origin;
      window.opener.location.href = `${baseUrl}/signup`;
      window.close();
    } else {
      router.push("/signup");
    }
  };

  /** フォーム送信エラー時: モーダルを閉じ、サインアップ画面へ遷移 */
  const handleError = () => {
    onClose();
    if (
      typeof window !== "undefined" &&
      window.opener &&
      !window.opener.closed
    ) {
      const baseUrl = window.location.origin;
      window.opener.location.href = `${baseUrl}/signup`;
      window.close();
    } else {
      router.push("/signup");
    }
  };

  return (
    <Modal
      opened={opened}
      close={onClose}
      centered
      size="md"
      padding="sm"
      radius="lg"
      withCloseButton
    >
      <Stack gap="lg" pb="lg">
        <Stack gap="sm" align="center">
          <Center
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              backgroundColor: "var(--mantine-color-blue-0)",
            }}
          >
            <EditIcon size="24px" color="var(--mantine-color-blue-6)" />
          </Center>
          <H3 ta="center">制限解除申請</H3>
          <Text size="sm" c="dimmed" ta="center">
            解除の理由やお問い合わせ内容をご記入の上、送信してください。
          </Text>
        </Stack>

        <AlertField type="warning" title="申請に関する注意事項" radius="md">
          <List size="xs" spacing="xs">
            <List.Item>
              審査完了まで数日〜1週間程度お時間をいただく場合がございます。
            </List.Item>
            <List.Item>
              申請内容や状況によっては、制限が解除されない場合があります。
            </List.Item>
          </List>
        </AlertField>

        <ReactivationRequestForm
          key={opened ? "open" : "closed"}
          onSuccess={handleSuccess}
          onError={handleError}
          phoneNumber={phoneNumber}
        />
      </Stack>
    </Modal>
  );
}
